export default {
  BankInfoCategoryCode: 'Mã loại tài khoản *',
  BankInfoCategoryName: 'Tên loại tài khoản *',
};
